import type { RecordOf } from 'immutable';
import { Record } from 'immutable';

import type { LiveStreamDTO } from './types/backend/liveStream';

export type LiveStreamEntry = {
  sportId: LiveStreamDTO['sportId'] | null;
  matchId: LiveStreamDTO['matchId'] | null;
  isLeading: LiveStreamDTO['isLeading'] | null;
  type: LiveStreamDTO['type'] | null;
  matchName: LiveStreamDTO['matchName'];
  sportName: LiveStreamDTO['sportName'];
  payload: LiveStreamDTO['payload'] | null;
};

export type RecordOfLiveStreamEntry = RecordOf<LiveStreamEntry>;

export const liveStreamEntry = Record<LiveStreamEntry>({
  sportId: null,
  matchId: null,
  isLeading: null,
  type: null,
  matchName: '',
  sportName: '',
  payload: null,
}, 'LiveStream');
